function graphemes(value) {
    if (typeof Intl !== 'undefined' && typeof Intl.Segmenter === 'function') {
        return Array.from(new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(value), ({ segment }) => segment);
    }

    return Array.from(value);
}

function displayHalfUnits(value) {
    return graphemes(value).reduce((total, grapheme) => {
        // This mirrors the server's width-1 / width-2 grouping. The server
        // remains authoritative if a browser classifies an uncommon glyph differently.
        const wide = /[\u1100-\u115f\u2329\u232a\u2e80-\ua4cf\uac00-\ud7a3\uf900-\ufaff\ufe10-\ufe19\ufe30-\ufe6f\uff00-\uff60\uffe0-\uffe6\u{1f000}-\u{1faff}]/u.test(grapheme);
        return total + (wide ? 2 : 1);
    }, 0);
}

function usedUnits(value, mode) {
    if (mode === 'grapheme') return graphemes(value).length * 2;
    return displayHalfUnits(value);
}

function formatRemaining(halfUnits, mode) {
    const value = Math.abs(halfUnits) / 2;
    const amount = Number.isInteger(value) ? String(value) : value.toFixed(1);
    const suffix = mode === 'display_unit' ? '文字分' : '文字';

    return halfUnits >= 0 ? `あと${amount}${suffix}` : `${amount}${suffix}超過`;
}

export function initTextLengthCounters(root = document) {
    if (!root?.querySelectorAll) return;

    root.querySelectorAll('[data-text-length-field]').forEach((input) => {
        if (!(input instanceof HTMLInputElement) && !(input instanceof HTMLTextAreaElement)) return;

        const field = input.dataset.textLengthField;
        const mode = input.dataset.textLengthMode || 'display_unit';
        const maximum = Number(input.dataset.textLengthMaximum);
        const status = field ? root.querySelector(`[data-text-length-status-for="${CSS.escape(input.id)}"]`) : null;
        if (!Number.isFinite(maximum) || maximum <= 0 || !(status instanceof HTMLElement)) return;

        const refresh = () => {
            const remaining = maximum * 2 - usedUnits(input.value, mode);
            const exceeded = remaining < 0;
            status.textContent = formatRemaining(remaining, mode);
            status.classList.toggle('is-over-limit', exceeded);
            input.toggleAttribute('data-text-length-exceeded', exceeded);
        };

        status.setAttribute('aria-live', 'polite');
        input.addEventListener('input', refresh);
        refresh();
    });
}
